import { Anchor } from "@mantine/core";

import anchor from "./Anchor.module.css";
import { HeaderNavMenu } from "./components";
import { getNavProps } from "./utils";

import type { MantineSize } from "@mantine/core";
import type { FC } from "react";
import type { NavLinkItem } from "./types";

export type HeaderNavLinkProps = NavLinkItem & {
  size?: MantineSize;
};

export const HeaderNavLink: FC<HeaderNavLinkProps> = ({ children, end, label, size, to }) => {
  if (children) {
    return (
      <HeaderNavMenu
        children={children}
        label={label}
        offset={24}
        position="bottom-start"
        radius="sm"
        size={size}
        shadow="md"
        to={to}
      />
    );
  }

  const props = getNavProps(to, end);
  return (
    <Anchor classNames={anchor} c="white" size={size} {...props}>
      {label}
    </Anchor>
  );
};
